import { ChangePassword } from "@/features/account/components/change-details/change-password";

const PasswordDetails = () => {
    return (
        <div className="px-4 py-8">
            <div className="container mx-auto">
                <h1 className="mb-4 text-2xl font-semibold">
                    Change your password
                </h1>
                <ChangePassword />
            </div>
        </div>
    );
};

export default PasswordDetails;
